export default __webpack_public_path__ + "2f1669acb7506d0693e05aa007b5700f.png";